import Axios from 'axios';
import moment from 'moment-timezone';
import { protectedResources } from '../authConfig';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/GetAdvanceSalarySchedules';
const URL_UPDATE =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/SetAdvanceSalaryScheduleUpdate';
//const token           = getAccessToken;
let tokenKey;

export async function GetSchedulers(prm_year = 0) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: prm_year,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
export async function UpdateSchedules(formInput) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  let timeOffset = new Date(formInput.startDate).getTimezoneOffset() * -1;
  let operation = timeOffset >= 0 ? '+' : '-';
  timeOffset = timeOffset < 0 ? timeOffset * -1 : timeOffset;
  let hrs = ('00' + parseInt((timeOffset / 60).toString()).toString()).slice(
    -2,
  );
  let mins = ('00' + parseInt((timeOffset % 60).toString()).toString()).slice(
    -2,
  );
  let timeOffsetStr = `${operation}${hrs}:${mins}`;
  console.log('timeOffset', timeOffset);
  console.log(
    moment(formInput.startDate).format('yyyy-MM-DDTHH:mm:ss.000') +
      timeOffsetStr,
  );

  formInput.startDate =
    moment(formInput.startDate).format('yyyy-MM-DDTHH:mm:00.000') +
    timeOffsetStr;
  formInput.endDate =
    moment(formInput.endDate).format('yyyy-MM-DDTHH:mm:00.000') + timeOffsetStr;

  const bodyParameters = {
    id: formInput.id,
    startDateStr: formInput.startDate,
    endDateStr: formInput.endDate,
  };
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };
  try {
    console.log('parmeters=', bodyParameters);
    const response = await Axios.post(URL_UPDATE, bodyParameters, config);
    return await { url: response.data };
  } catch (error) {
    //console.error(error);
    throw new Error(error.response.data.detail);
  }
}
